import React from 'react';
import {
    FormControl,
    InputLabel,
    TextField,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Paper,
    Divider
} from '@material-ui/core/';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// import SelectDataType from '@apricityhealth/web-common-lib/components/SelectDataType';
// import SelectTupleIndex from '@apricityhealth/web-common-lib/components/SelectTupleIndex';
import MultiSelectOrg from '@apricityhealth/web-common-lib/components/MultiSelectOrg';
import SelectOrg from '@apricityhealth/web-common-lib/components/SelectOrg';
import SelectTrial from '@apricityhealth/web-common-lib/components/SelectTrial';
import SelectModelType from '@apricityhealth/web-common-lib/components/SelectModelType';
import MultiSelectPlan from '@apricityhealth/web-common-lib/components/MultiSelectPlan';
import SelectPatient from '@apricityhealth/web-common-lib/components/SelectPatient';
import SelectProvider from '@apricityhealth/web-common-lib/components/SelectProvider';
import { MuiPickersUtilsProvider, TimePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { isArrayValid } from '@apricityhealth/web-common-lib/utils/Services';
import Logger from '@apricityhealth/web-common-lib/utils/Logger';
import ReactJson from 'react-json-view';

const log = new Logger();

// every parameter control renders full width inside its row; share a single style so they line up
const FIELD = { width: '100%', margin: 0 };
const LABEL = { fontSize: 12, display: 'block', marginBottom: 4 };

const TIMEZONE = (Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTZ');
const TIMEZONES = Object.freeze(
    [
        <MenuItem button key='UTZ' value='UTZ'>UTZ</MenuItem>,
        <MenuItem button key='America/Los_Angeles' value='America/Los_Angeles'>America/Los_Angeles</MenuItem>,
        <MenuItem button key='America/Denver' value='America/Denver'>America/Denver</MenuItem>,
        <MenuItem button key='America/Chicago' value='America/Chicago'>America/Chicago</MenuItem>,
        <MenuItem button key='America/New_York' value='America/New_York'>America/New_York</MenuItem>
    ]);

const ARG_TYPES = {
    "string": (appContext, self, arg) => {
        return <TextField key={arg.name} fullWidth style={FIELD}
            value={arg.value || ''}
            helperText={arg.description}
            onChange={(e) => {
                arg.value = e.target.value;
                self.onChange(arg);
            }} />
    },
    "stringarray": (appContex, self, arg) => {
        let { value } = arg;
        if (Array.isArray(value)) {
            value = value.join(',')
        }
        return <TextField key={arg.name} fullWidth style={FIELD}
            value={value || ''}
            helperText={arg.description}
            onChange={(e) => {
                arg.value = e.target.value.split(',');
                self.onChange(arg);
            }} />
    },
    "number": (appContext, self, arg) => {
        return <TextField key={arg.name} fullWidth style={FIELD}
            value={arg.value}
            helperText={arg.description}
            type='number'
            onChange={(e) => {
                arg.value = e.target.value;
                self.onChange(arg);
            }} />
    },
    "boolean": (appContex, self, arg) => {
        return <FormControlLabel key={arg.name} label={arg.description} control={
            <Checkbox checked={arg.value || false} onChange={(e, v) => {
                arg.value = v;
                self.onChange(arg);
            }} />} />
    },
    "orgid": (appContext, self, arg) => {
        if (!arg.value && arg.enableAll) arg.value = "*";
        if (arg.multiSelect) {
            return <MultiSelectOrg
                label={arg.description}
                appContext={appContext}
                selectedValue={arg.value}
                enableNone={!arg.required}
                enableAll={arg.enableAll}
                onChange={(org) => { arg.value = org.orgId; self.onChange(arg) }}
                style={FIELD}
                _margin={0}
            />
        } else {
            return <SelectOrg
                label={arg.description}
                appContext={appContext}
                orgId={arg.value}
                enableNone={!arg.required}
                enableAll={arg.enableAll}
                onChange={(orgId) => { arg.value = orgId; self.onChange(arg) }}
                style={FIELD}
            />
        }
    },
    "trialid": (appContext, self, arg) => {
        return <SelectTrial
            key={arg.name}
            label={arg.description}
            style={FIELD}
            appContext={appContext}
            selectedValue={arg.value}
            enableNone={true}
            onChange={(trialId) => { arg.value = trialId; self.onChange(arg) }}
        />
    },
    "modelid": (appContext, self, arg) => {
        let planArg = self.props.args.find(a => a.name === "planId"); //planId may be an args thats being set. Use it.
        if (planArg && planArg.value === "") planArg.value = "*"; //default value is a space and that causes issues in the select model type component
        appContext.state.plan = { planId: planArg ? planArg.value : "*" }
        let category = self.props.args.find(a => a.name === "category"); //this is to filter the model types by category
        if (category) category = category.value;
        return <SelectModelType
            style={FIELD}
            category={category}
            appContext={appContext}
            modelId={arg.value}
            onChange={(model) => { if (model) { arg.value = model.modelId; self.onChange(arg) } }}
        />
    },
    "datetime": (appContext, self, arg) => {
        return <MuiPickersUtilsProvider key={arg.name} utils={DateFnsUtils}>
            <InputLabel style={LABEL}>{arg.description}:</InputLabel>
            <KeyboardDateTimePicker
                margin="normal"
                fullWidth
                style={FIELD}
                ampm={true}
                value={arg.value}
                onChange={(time) => { arg.value = time; self.onChange(arg) }}
            />
        </MuiPickersUtilsProvider>;
    },
    "starttime": (appContext, self, arg) => {
        if (!arg.value) arg.value = null;
        return <MuiPickersUtilsProvider key={arg.name} utils={DateFnsUtils}>
            <InputLabel style={LABEL}>{arg.description}</InputLabel>
            <KeyboardDateTimePicker
                clearable
                margin="normal"
                fullWidth
                style={FIELD}
                ampm={true}
                value={arg.value}
                onChange={(time) => {
                    arg.value = time;
                    self.onChange(arg)
                }}
            />
        </MuiPickersUtilsProvider>;
    },
    "endtime": (appContext, self, arg) => {
        if (!arg.value) arg.value = null;
        return <MuiPickersUtilsProvider key={arg.name} utils={DateFnsUtils}>
            <InputLabel style={LABEL}>{arg.description}:</InputLabel>
            <KeyboardDateTimePicker
                clearable
                margin="normal"
                fullWidth
                style={FIELD}
                ampm={true}
                value={arg.value}
                onChange={(time) => { arg.value = time; self.onChange(arg) }}
            />
        </MuiPickersUtilsProvider>;
    },
    "endhourminute": (appContext, self, arg) => {
        return <MuiPickersUtilsProvider key={arg.name} utils={DateFnsUtils}>
            <InputLabel style={LABEL}>{arg.description}:</InputLabel>
            <TimePicker
                margin="normal"
                fullWidth
                style={FIELD}
                ampm={true}
                value={arg.value}
                onChange={(time) => { arg.value = time; self.onChange(arg) }}
            />
        </MuiPickersUtilsProvider>;
    },
    "beginhourminute": (appContext, self, arg) => {
        return <MuiPickersUtilsProvider key={arg.name} utils={DateFnsUtils}>
            <InputLabel style={LABEL}>{arg.description}:</InputLabel>
            <TimePicker
                margin="normal"
                fullWidth
                style={FIELD}
                ampm={true}
                value={arg.value}
                onChange={(time) => { arg.value = time; self.onChange(arg) }}
            />
        </MuiPickersUtilsProvider>;
    },
    "patientid": (appContext, self, arg) => {
        return <SelectPatient key={arg.name}
            style={FIELD}
            label={arg.description}
            appContext={appContext}
            patientId={arg.value}
            enableNone={!arg.required}
            enableAll={arg.enableAll}
            onChange={(patientId) => { arg.value = patientId; self.onChange(arg) }}
        />;
    },
    "providerid": (appContext, self, arg) => {
        return <SelectProvider key={arg.name}
            style={FIELD}
            label={arg.description}
            appContext={appContext}
            providerId={arg.value}
            enableNone={!arg.required}
            enableAll={arg.enableAll}
            onChange={(providerId) => { arg.value = providerId; self.onChange(arg) }}
        />;
    },
    "planid": (appContext, self, arg) => {
        if (!arg.value) arg.value = "";
        return <MultiSelectPlan
            style={FIELD}
            key={arg.name}
            label={arg.description}
            appContext={appContext}
            value={arg.value}
            enableAll={arg.enableAll}
            onChange={(planIds) => { arg.value = planIds.join(','); self.onChange(arg) }}
            _margin={0}
        />
    },
    "intervaltype": (appContext, self, arg) => {
        if (!arg.value) arg.value = 1;
        return <FormControl fullWidth style={FIELD} key={arg.name} >
            <InputLabel>{arg.description}</InputLabel>
            <Select
                value={arg.value}
                fullWidth
                onChange={(event) => { arg.value = event.target.value; self.onChange(arg) }}
            >
                <MenuItem value=''>None</MenuItem>
                <MenuItem value='day'>Day</MenuItem>
                <MenuItem value='week'>Week</MenuItem>
                <MenuItem value='month'>Month</MenuItem>
                <MenuItem value='year'>Year</MenuItem>
            </Select>
        </FormControl>
    },
    "timezone": (appContext, self, arg) => {
        if (!arg.value) arg.value = TIMEZONE;
        return <FormControl fullWidth style={FIELD} key={arg.name} >
            <InputLabel>{arg.description}</InputLabel>
            <Select
                value={arg.value}
                fullWidth
                onChange={(event) => { arg.value = event.target.value; self.onChange(arg) }}
            >
                {TIMEZONES}
            </Select>
        </FormControl>
    },
    "json": (appContext, self, arg) => {
        if (arg.value === undefined) arg.value = arg.default || (!arg.arrayRoot ? '{}' : '[]');

        let object = !arg.arrayRoot ? {} : [];
        try {
            object = JSON.parse(arg.value);
        } catch (err) {
            log.error('Failed to parse json:', err);
        }
        return <div style={{ width: '100%' }}>
            <Typography>{arg.description}</Typography>
            <Divider />
            <Paper key={arg.name} style={{ width: '100%', marginTop: 5 }}>
                <ReactJson src={object} name={'json'}
                    collapsed={3}
                    collapseStringsAfterLength={64}
                    displayDataTypes={false}
                    onEdit={(e) => {
                        log.info("onEdit:", e);
                        function castStringsToNumbers(cast) {
                            if (Array.isArray(cast) || typeof cast === 'object') {
                                for (let k in cast) {
                                    cast[k] = castStringsToNumbers(cast[k])
                                }
                            }
                            if (typeof cast === 'string' && !isNaN(Number(cast))) {
                                cast = Number(cast);
                            }
                            return cast;
                        }
                        arg.value = JSON.stringify(castStringsToNumbers(e.updated_src));
                        self.onChange(arg)
                        return true;
                    }}
                    onAdd={(e) => {
                        log.info("onAdd:", e);
                        if (Array.isArray(e.new_value)) {
                            if (e.new_value.find((k) => typeof (k) === 'object')) {
                                // array of objects, so convert any null into an object
                                for (let k in e.new_value) {
                                    if (e.new_value[k] === null) {
                                        e.new_value[k] = {};
                                    }
                                }
                            }
                        }
                        arg.value = JSON.stringify(e.updated_src);
                        self.onChange(arg)
                        return true;
                    }}
                    onDelete={(e) => {
                        log.info("onDelete:", e);
                        arg.value = JSON.stringify(e.updated_src);
                        self.onChange(arg)
                        return true;
                    }}
                />
            </Paper>
        </div>
    }
    // "dataid": (appContext, self, arg) => {
    //     return <SelectDataType appContext={appContext} value={arg.value} onChange={(dataType) => {
    //         console.log("SelectDataType:", dataType );
    //         arg.value = dataType.dataId;
    //         self.onChange(arg);
    //     }} />
    // },
    // "tupleindex": (appContext, self, arg) => {
    //     let dataIdArg = self.state.args.find((e) => e.type === 'dataId');
    //     if ( dataIdArg ) {
    //         return <SelectTupleIndex appContex={appContext} dataId={dataIdArg.value} tupleIndex={arg.value} onChange={(e) => {
    //             console.log("SelectTupleIndex:", e );
    //             arg.value = e;
    //             self.onChange(arg);
    //         }} />
    //     }
    // }
};

export class ReportParameters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            args: props.args,
            warning: null,
        };

    }

    componentDidUpdate(oldProps) {
        if (this.props.args !== oldProps.args)
            this.setState({ args: this.props.args });
    }


    onChange(newArg) {
        let { args } = this.state;
        let arg = args.find((item) => item.name === newArg.name);
        if (arg) {
            arg.value = newArg.value;
        }
        this.setState({ args });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(args);
        }
    }


    render() {
        let { args, warning } = this.state;
        let { appContext } = this.props;
        let items = [];

        if (isArrayValid(args)) {
            for (let i = 0; i < args.length; ++i) {
                let arg = args[i];
                if (!arg.value && arg.default)
                    arg.value = arg.default;
                let parameter = ARG_TYPES[(arg.type || 'string').toLowerCase()];         // fall-back to the old method using the arg name
                if (!parameter) {
                    log.warning(`arg type ${arg.type} not yet supported, defaulting to string.`);
                    parameter = ARG_TYPES['string'];
                }
                // each parameter gets its own full-width row so they stack cleanly and line up
                items.push(<div key={arg.name || i} style={styles.row}>{parameter(appContext, this, arg)}</div>);
            }
        }
        return <Accordion style={{ margin: 5 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <b>Report Parameters</b>
            </AccordionSummary>
            <AccordionDetails>
                <div style={styles.container}>
                    {warning && <div style={styles.warning}>{warning}</div>}
                    {items}
                </div>
            </AccordionDetails>
        </Accordion>;
    }
}

const styles = {
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        width: '100%',
        marginBottom: 16,
    },
    warning: {
        color: "#f54b20",
        marginBottom: 16,
    }
}

export default ReportParameters;
